import { IconExternalLink } from "@tabler/icons-react"
import { Button, Page, PageLink } from "@tfg/ui"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { config } from "~/pages/Brand/DataTransfer/config.ts"

export const DataTransferWrapper = () => {
  const { t } = useTranslation("dataTransfer")

  const pages = useMemo<PageLink[]>(() => {
    return [
      {
        label: t("tabs.import"),
        link: "import",
      },
      {
        label: t("tabs.export"),
        link: "export",
      },
    ]
  }, [t])

  return (
    <Page
      title={t("page.title")}
      pages={pages}
      mainCta={
        <Button
          variant="tertiary"
          component="a"
          target="_blank"
          rel="noopener noreferrer"
          href={config.DATA_TRANSFER_DOCS}
          rightSection={<IconExternalLink size="1rem" />}
        >
          {t("templateDocumentation")}
        </Button>
      }
    />
  )
}
